(function () {
  if (window.__customWeightInitialized) return;
  window.__customWeightInitialized = true;

  const MIN_WEIGHT = 0.1;
  const MAX_WEIGHT = 999;
  const EMPTY_ESTIMATE = '—';

  function formatMoney(dollars) {
    if (typeof window.formatMoney === 'function' && window.themeVariables?.settings?.moneyFormat) {
      return window.formatMoney(Math.round(dollars * 100), window.themeVariables.settings.moneyFormat);
    }
    return '$' + dollars.toFixed(2);
  }

  function parseWeight(value) {
    const weight = parseFloat(String(value).trim());
    if (!Number.isFinite(weight) || weight < MIN_WEIGHT || weight > MAX_WEIGHT) {
      return null;
    }
    return weight;
  }

  function getVariantPrices(element) {
    const jsonEl = element.querySelector('[data-custom-weight-prices]');
    if (!jsonEl) return {};
    try {
      return JSON.parse(jsonEl.textContent);
    } catch {
      return {};
    }
  }

  function getFormForElement(element) {
    const formId = element.dataset.formId;
    if (formId) {
      const byId = document.getElementById(formId);
      if (byId) return byId;
    }
    return element.closest('form[is="product-form"]');
  }

  function getVariantId(form, element) {
    const input = form?.querySelector('input[name="id"]');
    if (input?.value) return input.value;
    return element?.dataset?.variantId;
  }

  function getQuantity(form) {
    const qtyInput = form?.querySelector('input[name="quantity"]');
    const qty = parseInt(qtyInput?.value || '1', 10);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function getPricePerLbForUniqueSelector(uniqueSelector) {
    const variantInput =
      document.querySelector(`${uniqueSelector} form input[name="id"]`) ||
      document.querySelector(`${uniqueSelector} input[name="id"]`);
    const nativeVariant = document.querySelector(
      `${uniqueSelector} variant-radios input.native-variant:checked`
    );
    const variantId = variantInput?.value || nativeVariant?.dataset?.variantId;

    if (variantId && window.variantSpecs?.[variantId]?.price_lb != null) {
      const value = parseFloat(window.variantSpecs[variantId].price_lb);
      if (Number.isFinite(value)) return value;
    }

    const trimmed = uniqueSelector.trim();
    if (trimmed) {
      const scope = document.querySelector(trimmed);
      const productId = scope?.dataset?.productId;
      if (productId && window.productsVariantSpecs?.[productId]?.[variantId]?.price_lb != null) {
        const value = parseFloat(window.productsVariantSpecs[productId][variantId].price_lb);
        if (Number.isFinite(value)) return value;
      }
    }

    const container = document.querySelector(`${uniqueSelector} #product-options`);
    const fallback = parseFloat(container?.dataset.pricePerLb || '');
    return Number.isFinite(fallback) ? fallback : null;
  }

  function attachFoodifyPillLabelClick(input) {
    const label = input.labels?.[0] || input.nextElementSibling;
    if (!label || label.dataset.customWeightClickBound === 'true') return;
    label.dataset.customWeightClickBound = 'true';

    label.addEventListener('click', function (e) {
      e.stopPropagation();
      if (input.getAttribute('data-last-clicked') === 'true') {
        input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
        input.checked = false;
        input.setAttribute('data-last-clicked', 'false');
      } else {
        input.checked = true;
        document.querySelectorAll(`input[name="${input.name}"]`).forEach((radio) => {
          radio.setAttribute('data-last-clicked', 'false');
        });
        input.setAttribute('data-last-clicked', 'true');
        input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
      }
    });
  }

  function isCustomWeightRadioSelected(input) {
    return input?.checked && input.getAttribute('data-last-clicked') === 'true';
  }

  function updateCustomWeightPanelState(customField, showField, uniqueSelector, weightInput) {
    if (!customField) return;

    if (showField) {
      customField.hidden = false;
      customField.classList.add('is-visible');
      requestAnimationFrame(() => weightInput?.focus({ preventScroll: true }));
    } else {
      customField.classList.remove('is-visible');
      customField.hidden = true;
    }

    const pricePerLb = getPricePerLbForUniqueSelector(uniqueSelector);

    const weightProp = customField.querySelector('[data-foodify-custom-weight-property-weight]');
    const priceProp = customField.querySelector('[data-foodify-custom-weight-property-price-per-pound]');
    const estimateRow = customField.querySelector('[data-foodify-custom-weight-estimate]');
    const estimateValue = customField.querySelector('[data-foodify-custom-weight-estimate-value]');

    if (!showField) {
      if (weightInput) weightInput.value = '';
      if (weightProp) weightProp.value = '';
      if (priceProp) priceProp.value = '';
      return;
    }

    const weight = parseWeight(weightInput?.value || '');
    if (priceProp && pricePerLb != null) priceProp.value = pricePerLb.toFixed(2);
    if (weightProp) weightProp.value = weight != null ? `${weight} lb` : '';

    const hasEstimate = weight != null && pricePerLb != null;
    if (estimateRow) {
      estimateRow.hidden = false;
      estimateRow.classList.toggle('custom-weight__estimate--empty', !hasEstimate);
    }
    if (estimateValue) {
      estimateValue.textContent = hasEstimate
        ? formatMoney(Math.round(weight * pricePerLb * 100) / 100)
        : EMPTY_ESTIMATE;
    }
  }

  function syncFoodifyCustomWeightUi(uniqueSelector) {
    const fieldset = document.querySelector(
      `${uniqueSelector} .foodify-fieldset[data-custom-weight-injected="true"]`
    );
    if (!fieldset) return;

    const customField = fieldset.querySelector('.foodify-custom-weight-field');
    const customRadio = fieldset.querySelector('input[data-foodify-custom-weight="true"]');
    if (!customField || !customRadio) return;

    const showField = isCustomWeightRadioSelected(customRadio);
    const weightInput = customField.querySelector('[data-foodify-custom-weight-input]');
    updateCustomWeightPanelState(customField, showField, uniqueSelector, weightInput);
  }

  window.injectFoodifyCustomWeight = function (uniqueSelector, optionsData) {
    const container = document.querySelector(`${uniqueSelector} #product-options`);
    if (!container || container.dataset.customWeightEnabled !== 'true') return;

    const weightFieldset = window.findActiveFoodifyWeightFieldset?.(uniqueSelector, optionsData);
    if (!weightFieldset) return;

    if (weightFieldset.dataset.customWeightInjected !== 'true') {
      const optionsContainer = weightFieldset.querySelector('.options');
      const existingRadio = optionsContainer?.querySelector('input[type="radio"]');
      if (!optionsContainer || !existingRadio) return;

      const customId = `foodify-custom-weight-${Date.now()}`;
      const optionDiv = document.createElement('div');
      optionDiv.className = 'option';

      const input = document.createElement('input');
      input.type = 'radio';
      input.className = 'pill knhjd';
      input.id = customId;
      input.value = 'Custom';
      input.name = existingRadio.name;
      input.dataset.use = 'extra-option';
      input.dataset.price = '0';
      input.dataset.foodifyCustomWeight = 'true';

      const label = document.createElement('label');
      label.className = 'pill';
      label.setAttribute('for', customId);
      label.textContent = 'Custom';

      optionDiv.appendChild(input);
      optionDiv.appendChild(label);
      optionsContainer.appendChild(optionDiv);
      attachFoodifyPillLabelClick(input);

      const customField = document.createElement('div');
      customField.className = 'custom-weight__custom-field foodify-custom-weight-field';
      customField.hidden = true;
      customField.innerHTML = `
        <label class="custom-weight__custom-label" for="foodify-custom-weight-input-${customId}">Enter weight</label>
        <div class="custom-weight__input-row">
          <input
            id="foodify-custom-weight-input-${customId}"
            class="custom-weight__custom-input"
            type="text"
            inputmode="decimal"
            placeholder="e.g. 3.5"
            autocomplete="off"
            aria-describedby="foodify-custom-weight-estimate-${customId}"
            data-foodify-custom-weight-input
          >
          <span class="custom-weight__unit" aria-hidden="true">lb</span>
        </div>
        <p
          id="foodify-custom-weight-estimate-${customId}"
          class="custom-weight__estimate custom-weight__estimate--empty"
          data-foodify-custom-weight-estimate
        >
          <span class="custom-weight__estimate-label">Estimated total</span>
          <span class="custom-weight__estimate-value" data-foodify-custom-weight-estimate-value>${EMPTY_ESTIMATE}</span>
        </p>
        <input type="hidden" name="properties[weight]" value="" data-foodify-custom-weight-property-weight>
        <input type="hidden" name="properties[price_per_pound]" value="" data-foodify-custom-weight-property-price-per-pound>
      `;

      weightFieldset.appendChild(customField);

      const weightInput = customField.querySelector('[data-foodify-custom-weight-input]');
      weightInput?.addEventListener('input', () => {
        weightInput.classList.remove('custom-weight__custom-input--invalid');
        syncFoodifyCustomWeightUi(uniqueSelector);
        if (typeof updateOptionsPrice === 'function') {
          updateOptionsPrice(uniqueSelector);
        }
      });
      weightInput?.addEventListener('blur', () => {
        const value = weightInput.value?.trim();
        if (!value) {
          weightInput.classList.remove('custom-weight__custom-input--invalid');
          return;
        }
        weightInput.classList.toggle('custom-weight__custom-input--invalid', parseWeight(value) == null);
      });

      input.addEventListener('change', () => {
        syncFoodifyCustomWeightUi(uniqueSelector);
        if (typeof updateOptionsPrice === 'function') {
          updateOptionsPrice(uniqueSelector);
        }
      });

      weightFieldset.dataset.customWeightInjected = 'true';
    }

    syncFoodifyCustomWeightUi(uniqueSelector);
  };

  function getActiveFoodifyCustomWeightFieldset(uniqueSelector) {
    const fieldset = document.querySelector(
      `${uniqueSelector} .foodify-fieldset[data-custom-weight-injected="true"]`
    );
    if (!fieldset || fieldset.style.display === 'none' || fieldset.dataset.notIncluded === 'true') {
      return null;
    }

    const customRadio = fieldset.querySelector('input[data-foodify-custom-weight="true"]');
    if (!isCustomWeightRadioSelected(customRadio)) return null;

    return fieldset;
  }

  window.syncFoodifyCustomWeightUi = syncFoodifyCustomWeightUi;

  window.getFoodifyCustomWeightProperties = function (uniqueSelector) {
    const fieldset = getActiveFoodifyCustomWeightFieldset(uniqueSelector);
    if (!fieldset) return null;

    const weight = parseWeight(
      fieldset.querySelector('[data-foodify-custom-weight-input]')?.value || ''
    );
    const pricePerLb = getPricePerLbForUniqueSelector(uniqueSelector);
    if (weight == null || pricePerLb == null) return null;

    return {
      weight: `${weight} lb`,
      price_per_pound: pricePerLb.toFixed(2),
    };
  };

  window.getActiveFoodifyCustomWeightPrice = function (uniqueSelector) {
    const props = window.getFoodifyCustomWeightProperties(uniqueSelector);
    if (!props) return null;

    const weight = parseWeight(props.weight.replace(/\s*lb$/i, ''));
    const pricePerLb = parseFloat(props.price_per_pound);
    if (weight == null || !Number.isFinite(pricePerLb)) return null;

    return Math.round(weight * pricePerLb * 100) / 100;
  };

  window.validateFoodifyCustomWeight = function (uniqueSelector) {
    const fieldset = getActiveFoodifyCustomWeightFieldset(uniqueSelector);
    if (!fieldset) {
      return { valid: true };
    }

    const weight = parseWeight(
      fieldset.querySelector('[data-foodify-custom-weight-input]')?.value || ''
    );
    if (weight == null) {
      return { valid: false, message: 'Enter a valid weight (e.g. 3.5).' };
    }

    return { valid: true };
  };

  let variantChangeBound = false;

  function bindGlobalVariantChange() {
    if (variantChangeBound) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    variantChangeBound = true;

    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      document.querySelectorAll('custom-weight-selector[data-active="true"]').forEach((el) => {
        const form = getFormForElement(el);
        if (el.onVariantChange) {
          el.onVariantChange(getVariantId(form, el));
        }
      });
    });
  }

  class CustomWeightSelector extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      bindGlobalVariantChange();

      this.variantPrices = getVariantPrices(this);
      this.selectedMode = null;
      this.customWeightValue = '';

      this.presetsEl = this.querySelector('[data-custom-weight-presets]');
      this.customField = this.querySelector('[data-custom-weight-custom-field]');
      this.customInput = this.querySelector('[data-custom-weight-input]');
      this.estimateEl = this.querySelector('[data-custom-weight-estimate]');
      this.errorEl = this.querySelector('[data-custom-weight-error]');
      this.weightPropertyInput = this.querySelector('[data-custom-weight-property-weight]');
      this.pricePerPoundPropertyInput = this.querySelector('[data-custom-weight-property-price-per-pound]');

      this.bindEvents();
      this.syncFromVariant();
      this.updateEstimatedPrice();
    }

    bindEvents() {
      this.presetsEl?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-custom-weight-preset]');
        if (!button) return;
        this.selectPreset(button.dataset.customWeightPreset);
      });

      this.customInput?.addEventListener('input', () => {
        this.customWeightValue = this.customInput.value;
        this.customInput.classList.remove('custom-weight__custom-input--invalid');
        this.clearError();
        this.updateEstimatedPrice();
        this.syncHiddenProperties();
      });

      this.customInput?.addEventListener('blur', () => {
        const value = this.customInput?.value?.trim();
        if (!value) {
          this.customInput?.classList.remove('custom-weight__custom-input--invalid');
          return;
        }
        this.customInput?.classList.toggle(
          'custom-weight__custom-input--invalid',
          parseWeight(value) == null
        );
      });

      const form = getFormForElement(this);
      form?.querySelector('input[name="id"]')?.addEventListener('change', () => this.onVariantChange());
      form?.addEventListener('change', (event) => {
        if (event.target.matches('input[name="id"], .native-variant, input[data-variant-id]')) {
          this.onVariantChange();
        }
      });
    }

    disconnectedCallback() {}

    onVariantChange(variantId) {
      const form = getFormForElement(this);
      const id = variantId || getVariantId(form, this);
      const pricePerLb = this.variantPrices[id];
      if (pricePerLb != null) {
        this.dataset.pricePerLb = String(pricePerLb);
        this.dataset.variantId = id;
      }
      this.updateEstimatedPrice();
      this.syncHiddenProperties();
    }

    syncFromVariant() {
      const form = getFormForElement(this);
      this.onVariantChange(getVariantId(form, this));
    }

    getPricePerLb() {
      const value = parseFloat(this.dataset.pricePerLb || '');
      return Number.isFinite(value) ? value : null;
    }

    selectPreset(preset) {
      this.selectedMode = preset;
      this.clearError();

      this.querySelectorAll('[data-custom-weight-preset]').forEach((button) => {
        button.classList.toggle('is-selected', button.dataset.customWeightPreset === preset);
      });

      const isCustom = preset === 'custom';
      if (this.customField) {
        this.customField.hidden = !isCustom;
        this.customField.classList.toggle('is-visible', isCustom);
      }
      if (isCustom) {
        requestAnimationFrame(() => this.customInput?.focus({ preventScroll: true }));
      } else {
        this.customWeightValue = '';
        if (this.customInput) this.customInput.value = '';
      }

      this.updateEstimatedPrice();
      this.syncHiddenProperties();
    }

    getSelectedWeight() {
      if (!this.selectedMode) return null;
      if (this.selectedMode === 'custom') {
        return parseWeight(this.customInput?.value || this.customWeightValue);
      }
      return parseWeight(this.selectedMode);
    }

    getCalculatedPrice() {
      const weight = this.getSelectedWeight();
      const pricePerLb = this.getPricePerLb();
      if (weight == null || pricePerLb == null) return null;
      return Math.round(weight * pricePerLb * 100) / 100;
    }

    updateEstimatedPrice() {
      if (!this.estimateEl) return;
      const price = this.getCalculatedPrice();
      const valueEl = this.estimateEl.querySelector('[data-custom-weight-estimate-value]');
      if (!valueEl) return;

      if (!this.selectedMode) {
        this.estimateEl.hidden = true;
        return;
      }

      const isCustom = this.selectedMode === 'custom';
      const hasEstimate = price != null;

      this.estimateEl.hidden = false;
      this.estimateEl.classList.toggle('custom-weight__estimate--empty', !hasEstimate);
      valueEl.textContent = hasEstimate ? formatMoney(price) : EMPTY_ESTIMATE;
    }

    syncHiddenProperties() {
      const weight = this.getSelectedWeight();
      const pricePerLb = this.getPricePerLb();

      if (this.weightPropertyInput) {
        this.weightPropertyInput.value = weight != null ? `${weight} lb` : '';
      }
      if (this.pricePerPoundPropertyInput && pricePerLb != null) {
        this.pricePerPoundPropertyInput.value = pricePerLb.toFixed(2);
      }
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

    validate() {
      if (this.dataset.active !== 'true') return true;

      if (!this.selectedMode) {
        this.showError('Please select a weight.');
        return false;
      }
      if (this.selectedMode === 'custom') {
        const weight = parseWeight(this.customInput?.value || '');
        if (weight == null) {
          this.showError('Enter a valid weight (e.g. 3.5).');
          return false;
        }
      }
      if (this.getPricePerLb() == null) {
        this.showError('Price per lb is unavailable for this variant.');
        return false;
      }
      this.clearError();
      return true;
    }
  }

  if (!customElements.get('custom-weight-selector')) {
    customElements.define('custom-weight-selector', CustomWeightSelector);
  }

  function buildFormValues(form) {
    const formValues = {};
    new FormData(form).forEach((value, key) => {
      formValues[key] = value;
    });
    return formValues;
  }

  function resetSubmitButtons(form) {
    const submitButtons = Array.from(form.elements).filter((el) => el.type === 'submit');
    submitButtons.forEach((button) => {
      button.removeAttribute('disabled');
      button.removeAttribute('aria-busy');
    });
  }

  function setSubmitLoading(form, loading) {
    const submitButtons = Array.from(form.elements).filter((el) => el.type === 'submit');
    submitButtons.forEach((button) => {
      if (loading) {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-busy', 'true');
      } else {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-busy');
      }
    });
  }

  async function handleCustomWeightSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[is="product-form"]')) return;

    const selector = form.querySelector('custom-weight-selector[data-active="true"]');
    if (!selector) return;

    if (!selector.validate()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (typeof updateShopifyCart !== 'function') {
      console.error('updateShopifyCart is not available');
      return;
    }

    const variantId = getVariantId(form, selector);
    const quantity = getQuantity(form);
    const totalPrice = selector.getCalculatedPrice();
    const pricePerLb = selector.getPricePerLb();
    const weight = selector.getSelectedWeight();

    if (!variantId || totalPrice == null || weight == null || pricePerLb == null) {
      selector.showError('Unable to calculate price. Please try again.');
      return;
    }

    setSubmitLoading(form, true);

    const formValues = buildFormValues(form);
    formValues['properties[weight]'] = `${weight} lb`;
    formValues['properties[price_per_pound]'] = pricePerLb.toFixed(2);
    formValues.quantity = String(quantity);

    try {
      await updateShopifyCart(
        [{ id: variantId, quantity, price: totalPrice.toFixed(2) }],
        formValues,
        form
      );

      if (
        window.themeVariables?.settings?.cartType === 'page' ||
        window.themeVariables?.settings?.pageType === 'cart'
      ) {
        window.location.href = `${Shopify.routes.root}cart`;
      }
    } catch (error) {
      console.error('Custom weight add to cart failed:', error);
      selector.showError('Could not add to cart. Please try again.');
    } finally {
      resetSubmitButtons(form);
    }
  }

  document.addEventListener('submit', handleCustomWeightSubmit, true);

  function getLineItemDisplayTotalCents(item) {
    const customPrice = item.properties?._price;
    if (customPrice != null && customPrice !== '') {
      const customCents = Math.round(parseFloat(customPrice) * 100);
      if (Number.isFinite(customCents) && customCents > item.price) {
        return customCents * item.quantity;
      }
    }
    return item.final_line_price;
  }

  function getCartApproxTotalCents(cart) {
    if (!cart?.items?.length) return 0;

    let total = cart.items.reduce((sum, item) => sum + getLineItemDisplayTotalCents(item), 0);
    const discounts = cart.cart_level_discount_applications || [];
    for (const discount of discounts) {
      total -= discount.total_allocated_amount;
    }
    return total;
  }

  function formatCartTotal(cents) {
    const settings = window.themeVariables?.settings;
    if (typeof window.formatMoney === 'function' && settings) {
      const format = settings.currencyCodeEnabled
        ? settings.moneyWithCurrencyFormat
        : settings.moneyFormat;
      return window.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartTotalDisplays(cart) {
    if (!cart) return;
    const formatted = formatCartTotal(getCartApproxTotalCents(cart));
    document.querySelectorAll('.cart-total-element').forEach((el) => {
      el.textContent = formatted;
    });
  }

  window.getCartApproxTotalCents = getCartApproxTotalCents;
  window.updateCartTotalDisplays = updateCartTotalDisplays;

  document.addEventListener('cart:change', (event) => {
    const cart = event.detail?.cart;
    if (cart) updateCartTotalDisplays(cart);
  });

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof Shopify === 'undefined' || !Shopify.routes?.root) return;
    fetch(`${Shopify.routes.root}cart.js`)
      .then((response) => response.json())
      .then(updateCartTotalDisplays)
      .catch(() => {});
  });
})();
